export const asMention = {
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.66683 2.66634H13.3335V10.6663H3.44683L2.66683 11.4463V2.66634ZM2.66683 1.33301C1.9335 1.33301 1.34016 1.93301 1.34016 2.66634L1.3335 14.6663L4.00016 11.9997H13.3335C14.0668 11.9997 14.6668 11.3997 14.6668 10.6663V2.66634C14.6668 1.93301 14.0668 1.33301 13.3335 1.33301H2.66683ZM4.00016 7.99967H9.3335V9.33301H4.00016V7.99967ZM4.00016 5.99967H12.0002V7.33301H4.00016V5.99967ZM4.00016 3.99967H12.0002V5.33301H4.00016V3.99967Z"/>
  </svg>
`,
  name: 'mention',
};
